import React from 'react';
import { connect } from "react-redux";
import { Route, Routes, useLocation } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import Helpers from './components/helpers/Helpers';
import Layout from './components/Layout';
import { store } from './index';
import * as AppDataStore from './store/AppData';

import './custom.css';
let startLoading = false;
const App = (props) => {
    return (<>
  
            <Routes>
                {AppRoutes.map((route, index) => {
                    const { element, ...rest } = route;
                    return <Route key={index} {...rest} element={element} />;
                })}
            </Routes>
      
    </>
    );
}
export default connect(null, { ...AppDataStore.actionCreators })(App);
